// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopBar_container__q6CLb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  padding-bottom: 10px;
}

/* Breadcrumb */
.TopBar_breadcrumb__kyGPK {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #444;
  padding: 10px 25px;
  background-color: #fff; /* Alb */
  border: 1px solid #ddd; /* Margine */
  border-radius: 5px;
  color: #d32f2f;
}

.TopBar_separator__gpW86 {
  margin: 0 5px;
  color: #d32f2f; /* Gri pentru separator */
}

/* Bara de căutare */
.TopBar_searchBar__UB15s {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0px;
}

/* Câmpul de căutare */
.TopBar_searchInput__mNTZc {
  display: flex;
  align-items: center;
  background-color: transparent; /* Fără culoare de fundal */
  border: none; /* Elimină marginea */
  border-radius: 5px;
  /* overflow: hidden; */
  position: relative;
}

.TopBar_input__GCGEZ {
  border: 1px solid #ccc; /* Adaugă o margine doar pentru input */
  border-right: none; /* Elimină marginea din partea dreaptă */
  border-radius: 5px 0 0 5px; /* Rotunjire doar pentru colțurile stânga sus și jos */
  padding: 8px;
  font-size: 14px;
  width: 200px; /* Dimensiune fixă pentru câmpul de căutare */
  outline: none;
}

.TopBar_searchButton__dVNd4 {
  background-color: #d32f2f;
  color: white;
  border: none;
  border-left: none; /* Elimină marginea din partea dreaptă */
  border-radius: 0 5px 5px 0; /* Rotunjire doar pentru colțurile stânga sus și jos */
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
}

.TopBar_searchButton__dVNd4:hover {
  background-color: #b71c1c;
}

.TopBar_resultsContainer__5Dc63 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: #fff;
  z-index: 10;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.TopBar_resultItem__UkqZW {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
  text-decoration: none;
}

.TopBar_resultItem__UkqZW:hover {
  background-color: #f9f9f9;
}

.TopBar_resultImage__EURyn {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 10px;
  border-radius: 4px;
}

.TopBar_resultName__SsZ9D {
  color: black;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}

.TopBar_resultDetails__Kcl8j {
  font-size: 14px;
  color: #555;
  margin: 5px 0;
}

.TopBar_resultPrice__aq91K {
  font-size: 14px;
  color: #e53935;
  font-weight: bold;
}

.TopBar_noResults__MOdeO {
  padding: 5px;
  font-size: 18px;
  text-align: center;
  color: #888;
}

.TopBar_category__4gLag {
  color: #d32f2f;
  text-decoration: none; /* Elimină underline-ul */
}

.TopBar_category__4gLag:hover {
  color: #b71c1c;
  cursor: pointer;
  text-decoration: underline;
}

.TopBar_productName__v2xdL {
  color: gray;
}
`, "",{"version":3,"sources":["webpack://./src/components/Product/TopBar/TopBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,sBAAsB,EAAE,QAAQ;EAChC,sBAAsB,EAAE,YAAY;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc,EAAE,yBAAyB;AAC3C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B,EAAE,2BAA2B;EAC1D,YAAY,EAAE,qBAAqB;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB,EAAE,uCAAuC;EAC/D,kBAAkB,EAAE,wCAAwC;EAC5D,0BAA0B,EAAE,sDAAsD;EAClF,YAAY;EACZ,eAAe;EACf,YAAY,EAAE,6CAA6C;EAC3D,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE,wCAAwC;EAC3D,0BAA0B,EAAE,sDAAsD;EAClF,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB,EAAE,yBAAyB;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 5px;\n  padding-bottom: 10px;\n}\n\n/* Breadcrumb */\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #444;\n  padding: 10px 25px;\n  background-color: #fff; /* Alb */\n  border: 1px solid #ddd; /* Margine */\n  border-radius: 5px;\n  color: #d32f2f;\n}\n\n.separator {\n  margin: 0 5px;\n  color: #d32f2f; /* Gri pentru separator */\n}\n\n/* Bara de căutare */\n.searchBar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0px;\n}\n\n/* Câmpul de căutare */\n.searchInput {\n  display: flex;\n  align-items: center;\n  background-color: transparent; /* Fără culoare de fundal */\n  border: none; /* Elimină marginea */\n  border-radius: 5px;\n  /* overflow: hidden; */\n  position: relative;\n}\n\n.input {\n  border: 1px solid #ccc; /* Adaugă o margine doar pentru input */\n  border-right: none; /* Elimină marginea din partea dreaptă */\n  border-radius: 5px 0 0 5px; /* Rotunjire doar pentru colțurile stânga sus și jos */\n  padding: 8px;\n  font-size: 14px;\n  width: 200px; /* Dimensiune fixă pentru câmpul de căutare */\n  outline: none;\n}\n\n.searchButton {\n  background-color: #d32f2f;\n  color: white;\n  border: none;\n  border-left: none; /* Elimină marginea din partea dreaptă */\n  border-radius: 0 5px 5px 0; /* Rotunjire doar pentru colțurile stânga sus și jos */\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.searchButton:hover {\n  background-color: #b71c1c;\n}\n\n.resultsContainer {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  z-index: 10;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.resultItem {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  text-decoration: none;\n}\n\n.resultItem:hover {\n  background-color: #f9f9f9;\n}\n\n.resultImage {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  margin-right: 10px;\n  border-radius: 4px;\n}\n\n.resultName {\n  color: black;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.resultDetails {\n  font-size: 14px;\n  color: #555;\n  margin: 5px 0;\n}\n\n.resultPrice {\n  font-size: 14px;\n  color: #e53935;\n  font-weight: bold;\n}\n\n.noResults {\n  padding: 5px;\n  font-size: 18px;\n  text-align: center;\n  color: #888;\n}\n\n.category {\n  color: #d32f2f;\n  text-decoration: none; /* Elimină underline-ul */\n}\n\n.category:hover {\n  color: #b71c1c;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.productName {\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TopBar_container__q6CLb`,
	"breadcrumb": `TopBar_breadcrumb__kyGPK`,
	"separator": `TopBar_separator__gpW86`,
	"searchBar": `TopBar_searchBar__UB15s`,
	"searchInput": `TopBar_searchInput__mNTZc`,
	"input": `TopBar_input__GCGEZ`,
	"searchButton": `TopBar_searchButton__dVNd4`,
	"resultsContainer": `TopBar_resultsContainer__5Dc63`,
	"resultItem": `TopBar_resultItem__UkqZW`,
	"resultImage": `TopBar_resultImage__EURyn`,
	"resultName": `TopBar_resultName__SsZ9D`,
	"resultDetails": `TopBar_resultDetails__Kcl8j`,
	"resultPrice": `TopBar_resultPrice__aq91K`,
	"noResults": `TopBar_noResults__MOdeO`,
	"category": `TopBar_category__4gLag`,
	"productName": `TopBar_productName__v2xdL`
};
export default ___CSS_LOADER_EXPORT___;
